import { create } from 'zustand';

const useFileUploadStore = create((set) => ({
    isDragActive: false,
    setIsDragActive: (isDragActive) => set({ isDragActive }),
}));

export default useFileUploadStore;
